<div class="wallboardViewSlide">
    <div [id]="playerID"></div>
</div>
